import { render, staticRenderFns } from "./NominatedContacts.vue?vue&type=template&id=92270258&"
import script from "./NominatedContacts.vue?vue&type=script&lang=js&"
export * from "./NominatedContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports